import { AfterViewInit, Component, ElementRef, Inject, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { HasSubscription } from 'src/app/interfaces/services/subscription.interface';
import { Observable, Subject } from 'rxjs';
import { faQuestionCircle, faCheckCircle, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { CloudSubscriptionService } from 'src/app/cloud-subscription/services/cloud-subscription.service';
import { CloudNotificationService } from 'src/app/services/cloud-notification.service';
import { CloudNotificationStyle } from 'src/app/models/cloud-notification-style.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { OTPVerificationRequest } from 'src/app/models/requests/otp-verification-request';
import { takeUntil } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Helper from 'src/app/Util/helper';
import { environment } from 'src/environments/environment';
import { CloudAuthenticationService } from 'src/app/services/cloud-authentication.service';
import { AuthenticationService } from '../../services/authentication.service';
import { AuthUtils } from 'src/app/Util/auth-utils';
import { HttpErrorResponse } from '@angular/common/http';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { userType } from 'src/app/models/user-type.model';
import { version, projectName } from '../../../../../package.json'
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass']
})

export class LoginComponent implements OnInit, AfterViewInit, HasSubscription {

  private unsubscribe$ = new Subject<void>()
  private otpInterval: any

  verificationOTP: string
  verificationEmail: string
  verifiationPassword: string
  vendor: string

  faArrowLeft = faArrowLeft;
  emailFormSubmitted = false;
  passwordFormSubmitted = false;
  isEmailVerificationLoading = false;
  isPasswordVerificationLoading = false;
  emailAndPasswordFormSubmitted = false

  loginHeading: string = "Sign In";
  formEmailGroup: FormGroup;
  formPasswordGroup: FormGroup;
  emailSent = false;
  email_exists = false;
  verifyOtpLoading: boolean = false;
  resendOtpLoading: boolean = false;
  resendSuccessful: boolean = false;
  substr = '';
  completeStateid = '';
  faQuestionCircle = faQuestionCircle;
  faCheckCircle = faCheckCircle;
  faEye = faEye
  faEyeSlash = faEyeSlash

  stateId = '';
  state = '';
  incorrect_password = false;
  otpVerifyDisabled = true;
  unverifiedUser = false;
  resendAllowed: boolean = true;
  passwordShow: boolean = false;
  unsubscribeSubject = new Subject();
  formEmailAndPasswordGroup: FormGroup

  otpCounter: number = 0;

  @ViewChild('verificationOTPModal', { static: false }) verificationOTPModal: ElementRef;
  @ViewChildren('passwordField') passwordField!: QueryList<ElementRef>;
  @ViewChild('exampleInputEmail1') emailField!: ElementRef

  constructor(
    @Inject(DOCUMENT) document: Document,
    private route: ActivatedRoute,
    private router: Router,
    private subscriptionSvc: CloudSubscriptionService,
    private notificationSvc: CloudNotificationService,
    private formBuilder: FormBuilder,
    private modalSvc: NgbModal,
    private readonly cloudAuthSvc: CloudAuthenticationService,
    private readonly authSvc: AuthenticationService,
    private renderer: Renderer2
  ) { }
  ngAfterViewInit(): void {

    this.getAuthCodeFromQueryParamsIfAny();
    this.emailField.nativeElement.focus()
  }

  ngOnInit(): void {

    this.initializeForms();

    if (this.cloudAuthSvc.isAuthenticated()) {
      this.router.navigate([environment.routes.subscription]);
    }
    if (history.state && history.state?.isSubExists) {
      this.notificationSvc.createToastNotification('subscription',
        'A subscription using the same marketplace token already exists. Please sign in to continue.',
        CloudNotificationStyle.danger);
        //now make the state null
      history.replaceState({}, document.title);
    }
  }

  private initializeForms(): void {
    this.formEmailGroup = this.formBuilder.group({ email: ['', [Validators.required, Validators.email]] });
    this.formPasswordGroup = this.formBuilder.group({ password: ['', Validators.required] });
    this.formEmailAndPasswordGroup = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }

  get emailForm() {
    return this.formEmailGroup.controls;
  }

  get emailAndPasswordForm() {
    return this.formEmailAndPasswordGroup.controls
  }

  get passwordForm() {
    return this.formPasswordGroup.controls;
  }

  private getAuthCodeFromQueryParamsIfAny(): void {
    this.route.queryParams.subscribe(param => {
      if (param.code) {
        this.handleAuthCode(param.code, param.error);
      }
    })
  }

  private handleAuthCode(authCode: string, error: string): void {
    const { email, password } = AuthUtils.decodeAuthCode(authCode);
    this.email_exists = true;
    this.verificationEmail = email;
    this.verifiationPassword = password;
    this.emailAndPasswordForm.email.setValue(email);
    this.passwordForm.password.setValue(this.verifiationPassword);

    if (error === 'unverified') {
      this.openModal(this.verificationOTPModal);
    } else {
      this.incorrect_password = true;
    }
  }

  private checkEmailExists(email: string): void {

    this.isEmailVerificationLoading = true;

    this.authSvc.checkEmailExists(email).pipe(takeUntil(this.unsubscribe$)).subscribe({

      next: (user) => {
        if (user === userType.Primary) {
          this.email_exists = true;
          this.isEmailVerificationLoading = false;
          setTimeout(() => {
            this.passwordField?.first.nativeElement.focus()
          }, 10)
        }
        else {
          this.notificationSvc.createToastNotification('subscription',
            'Please subscribe to "NCache SaaS offering(s)" from Azure or AWS marketplace',
            CloudNotificationStyle.warning);
          this.isEmailVerificationLoading = false;
        }

      },

      error: (error: HttpErrorResponse) => {
        this.isEmailVerificationLoading = false;
        this.notificationSvc.createToastNotification('subscription', Helper.resolveErrorMessage(error), CloudNotificationStyle.danger);
      }

    })

  }




  private isUserEmailVerified(): void {

    const encoded_email = AuthUtils.encodeToBase64(this.emailForm.email.value)

    this.subscriptionSvc.isEmailVerified({ email: encoded_email }).pipe(takeUntil(this.unsubscribe$)).subscribe({

      next: (verified) => {

        this.isPasswordVerificationLoading = false

        if (verified) {
          const authCode = AuthUtils.encodeEmailAndPassword(this.emailForm.email.value, this.passwordForm.password.value)
          this.router.navigate([`/auth/signin/subscriptions`], { queryParams: { code: authCode } })

        } else {
          this.openModal(this.verificationOTPModal)
        }

      },

      error: (err: HttpErrorResponse) => {

        this.isPasswordVerificationLoading = false

        const error = Helper.resolveErrorMessage(err);
        if (typeof error === 'number') {
          this.resendOtpLoading = false;
          this.startOtpCountdown(error)

          this.notificationSvc.createToastNotification(
            'registration',
            `You are not allowed to resend OTP again. Please wait for ${error} seconds.`,
            CloudNotificationStyle.danger
          );

          this.openModal(this.verificationOTPModal);
        }
        else {
          if (!isNaN(Number(error))) {
            this.openModal(this.verificationOTPModal);
          }
        }
      }
    })

  }

  backToEmailForm() {
    this.email_exists = false;
    this.isEmailVerificationLoading = false;
  }

  onSubmitEmail() {

    this.emailFormSubmitted = true;

    if (!this.emailForm.email?.valid) {
      return;
    }

    this.verificationEmail = this.emailForm.email.value;
    const encoded_email = AuthUtils.encodeToBase64(this.emailForm.email.value);
    this.checkEmailExists(encoded_email);
    this.passwordForm.password.setValue('');
  }

  onSubmitPassword() {
    this.passwordFormSubmitted = true;

    if (!this.passwordForm.password.valid) {
      return;
    }

    this.isPasswordVerificationLoading = true

    this.verifiationPassword = this.passwordForm.password.value

    const authCode = AuthUtils.encodeEmailAndPassword(this.emailForm.email.value, this.passwordForm.password.value)
    this.router.navigate([`/auth/signin/subscriptions`], { state: { code: authCode } })

    //this.isUserEmailVerified()
  }

  onSubmitEmailAndPassword() {
    this.emailAndPasswordFormSubmitted = true

    if (!this.emailAndPasswordForm.email?.valid) {
      return;
    }

    if (!this.emailAndPasswordForm.password.valid) {
      return;
    }

    const authCode = AuthUtils.encodeEmailAndPassword(this.emailAndPasswordForm.email.value, this.emailAndPasswordForm.password.value)
    this.router.navigate([`/auth/signin/subscriptions`], { state: { code: authCode } })
  }


  hasSubscription(): Observable<string> {
    return this.subscriptionSvc.hasSubscription();
  }

  verifyOTP(): void {

    let request = new OTPVerificationRequest();
    request.email = this.verificationEmail;
    request.otp = this.verificationOTP;
    this.verifyOtpLoading = true;
    this.otpVerifyDisabled = true;

    this.subscriptionSvc.verifyOTP(this.verificationEmail, this.verificationOTP).pipe(takeUntil(this.unsubscribeSubject)).subscribe(res => {
      this.verifyOtpLoading = false;
      this.otpVerifyDisabled = false;

      this.notificationSvc.createToastNotification(
        'registration',
        res,
        CloudNotificationStyle.success
      )

      const concated_code = AuthUtils.encodeEmailAndPassword(this.verificationEmail, this.verifiationPassword)
      this.closeModal();
      this.router.navigate(['/auth/signin/subscriptions'], { state: { code: concated_code } });

    }, err => {

      this.verifyOtpLoading = false;
      this.otpVerifyDisabled = false;
      this.notificationSvc.createToastNotification(
        'registration',
        Helper.resolveErrorMessage(err),
        CloudNotificationStyle.danger
      );
    });
  }

  resendOTP(): void {

    this.resendSuccessful = false;
    this.resendOtpLoading = true;
    let request = new OTPVerificationRequest();
    request.email = this.verificationEmail;

    this.subscriptionSvc.resendOTP(this.verificationEmail).pipe(takeUntil(this.unsubscribeSubject)).subscribe(res => {

      this.resendOtpLoading = false
      this.resendSuccessful = true
      this.resendAllowed = false
      this.startOtpCountdown(60)

      this.notificationSvc.createToastNotification(
        'registration',
        res,
        CloudNotificationStyle.success
      );
    },
      (error) => {

        this.resendOtpLoading = false;
        const err = Helper.resolveErrorMessage(error);

        this.startOtpCountdown(this.otpCounter)

        this.notificationSvc.createToastNotification(
          'registration',
          `You are not allowed to resend OTP again. Please wait for ${err} seconds.`,
          CloudNotificationStyle.danger
        );
      });
  }

  verificationOTPConsentChange(value: string) {
    this.otpVerifyDisabled = value !== '' ? false : true;
    this.verificationOTP = value;
  }

  openModal(modal: ElementRef<any>) {
    this.modalSvc.open(modal, { windowClass: "verificationOTPModal", backdrop: 'static', keyboard: false, centered: true });
  }

  closeModal() {
    this.modalSvc.dismissAll();
    this.passwordFormSubmitted = false;
    this.isPasswordVerificationLoading = false;
  }

  onPasswordShowClick(passwordField: string) {
    if ('passwordShow' === passwordField) {
      this.passwordShow = !this.passwordShow;
    }
  }

  private startOtpCountdown(seconds: number): void {

    this.otpCounter = seconds

    if (this.otpInterval) {
      clearInterval(this.otpInterval)
    }

    this.otpInterval = setInterval(() => {

      if (this.otpCounter > 0) {
        this.otpCounter--

      } else {
        clearInterval(this.otpInterval)
      }

    }, 1000)

  }

  navigateToForgotPassword() {
    const encoded_email = AuthUtils.encodeToBase64(this.emailForm.email.value);
    this.router.navigate([environment.routes.forgot_password], { queryParams: { email: encoded_email } });
  }

  getProjectVersionAndName() {
    return projectName + ' -v' + version
  }

}
